import { MarketView } from "../../marketView/objects/marketView";
import { Picture } from "../../picture/objects/picture";
import { Place } from "../../place/objects/place";
import { RecommendedAccommodation } from "../../recommendedAccommodation/objects/recommendedAccommodation";
import { ClosedDay } from "./closedDay";
import { Holiday } from "./holiday";
import { ManualActivityLocalized } from "./manualActivityLocalized";
import { ManualActivityPrice } from "./manualActivityPrice";
import { OpenDays } from "./openDays";

export enum ProductMarketType {
    ALL = 'ALL',
    BY_CREATED_MARKET = 'BY_CREATED_MARKET',
    BY_SPECIFIC_MARKET = 'BY_SPECIFIC_MARKET',
}
export interface ManualActivityVariant {
    id: number;
    name: string;
    rating: number;
    duration: number;
    recommended: boolean;
    hide_hours: boolean;
    guide: boolean;
    multiple_days: boolean;
    consecutive_day: boolean;
    for_children: boolean;
    for_disabled: boolean;
    cut_line: boolean;
    guide_lang: string[];
    audio_guide: boolean;
    poi_type: boolean;
    localization: ManualActivityLocalized[];
    title: string;
    need_pax_weight: boolean;
    need_pax_height: boolean;
    special_attribute: null | 'TRANSPORT_PASS' | 'GUIDE';
    pictures: Picture[];
    included: null | string[];
    not_included: null | string[];
    provider_name: null | string;
    provider_lib: null | string;
    provider_ref: null | string;
    voucher_text: null | string;
    long_description: null | string;
    short_description: null | string;
    good_to_know: null | string;
    place: null | Place;
    pax_height_unit: 'CENTIMETRE' | 'INCH';
    pax_weight_unit: 'KILO' | 'POUND';
    pax_height_data: number;
    pax_weight_data: number;
    schedules: OpenDays[];

    selected_holidays: (Holiday & { localization?: any})[]
    closed_days: ClosedDay[];

    is_active: boolean;


    meeting_point: 'PLACE' | 'HOTEL' | 'OPEN_FIELD';
    place_meeting_point: Place[];
    hotel_meeting_point: RecommendedAccommodation[];
    open_field_meeting_point: string;

    return_point: 'PLACE' | 'HOTEL' | 'OPEN_FIELD';
    place_return_point: Place[];
    hotel_return_point: RecommendedAccommodation[];
    open_field_return_point: string;

    identical_meeting_and_return_points: boolean;

    daily_duration: number;

    variant_prices?: ManualActivityPrice[];

    allowed_markets: MarketView[],
    market_type: ProductMarketType,
    sub_market: MarketView | null,
}